import React from "react";

import { color } from "minimum-ui/tokens";
import styled from "styled-components";
import { H4M } from "typography/headers";

import { pluralise } from "utils/strings";

interface TableFilterSelectAllProps {
  count: number;
  actionText: string;
  onAction: () => void;
}

const TableFilterSelectAll: React.FC<TableFilterSelectAllProps> = ({
  count,
  actionText,
  onAction,
}) => {
  return (
    <H4M>
      {count}
      {pluralise(" row", count)} selected (
      <TextAction onClick={onAction}>{actionText}</TextAction>)
    </H4M>
  );
};

const TextAction = styled.span`
  text-decoration: underline;
  color: ${color.blue[300]};
  cursor: pointer;
`;

export default TableFilterSelectAll;
